import { Box, Typography } from "@mui/material";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";

// A small component to handle the display of a single thought.
const ThoughtItem = ({ text }) => {
  return (
    <Box sx={{ border: "1px solid #444", p: 0, mb: 0, borderRadius: "4px", background: "#1c1c1c", ml: 1, mr: 1 }}>
      <Typography sx={{ color: `${PureLightThemeCaaS.colors.alpha.white[100]}`, fontStyle: "italic", mb: 2, textAlign: "center" }}>
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{text}</ReactMarkdown>
      </Typography>
    </Box>
  );
};

export default ThoughtItem;